<div class="full-width flex-utility direction-column align-center justify-center not-authorized-page">
  <div class="logo-wrapper flex-utility direction-column align-center">
    <img src="../../../assets/images/bulgari-logo.svg" alt="events-logo" />
  </div>
  <span> {{'USER_NOT_AUTHORIZED' | translate }} </span>

  <app-bulgari-button [customStyle]="'height: 40px;'" [full]="true" [type]="'flat'"
    [text]="'GO_HOME' | translate" routerLink="/home"></app-bulgari-button>
  <app-bulgari-button (click)="logout()" [customStyle]="'height: 40px; margin-top: 40px;'" [full]="true"
    [type]="'black'" [text]="'LOGOUT' | translate"></app-bulgari-button>

</div>